import { Direction } from "../../../DirectionalButtons/DirectionButton";

export const managePointer = (currentSelected:  number, direction: Direction, numberOfOptions: number, cb?: () => void) => {
    let newSelection: number = 0;

    if (direction === 'up') {
        if (currentSelected <= 1) {
            newSelection = currentSelected
        } else {
            cb?.();
            newSelection = (currentSelected - 2);
        }
    }

    if (direction === 'right') {
        if (currentSelected !== (numberOfOptions - 1)) {
            if (currentSelected % 2 === 0) {
                cb?.()
               newSelection = currentSelected + 1;
            } else {
                newSelection = currentSelected;
            }
        } else return currentSelected;
    }

    if (direction === 'down') {

        if ((currentSelected + 2) >= numberOfOptions) {
            newSelection = currentSelected;
        } else {
            cb?.();
            newSelection = (currentSelected + 2);
        }
    }

    if (direction === 'left') {
        if (currentSelected % 2 !== 0 )  {
            cb?.();
            newSelection = currentSelected - 1
        } else {
            newSelection = currentSelected
        }
    }

   return newSelection;
}